import { render, staticRenderFns } from "./basic-chart-input.vue?vue&type=template&id=088e1d46&"
import script from "./basic-chart-input.vue?vue&type=script&lang=js&"
export * from "./basic-chart-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports